import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SUBMIT_BUTTON: `${cleanedFilename(__filename)}-submit-button`,
  CANCEL_BUTTON: `${cleanedFilename(__filename)}-cancel-button`,
  INPUT: `${cleanedFilename(__filename)}-input`,
};
